// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import { ShareType } from '../../services';
import { AbstractModuleUi } from '../_abstract/ui';
import { Addon } from '../_contracts';
import { ArticleHeader } from '../_components/ui';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { AdBannerModuleUi } from '../AdBanner/AdBanner.ui';
/**
 * Component capable of rendering the `ArticleTeaser's` contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
let ArticleTeaserModuleUi = class ArticleTeaserModuleUi extends AbstractModuleUi {
    constructor() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9;
        super(...arguments);
        this.cover = ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.hasProperty(Addon.Cover)) ? this.parent.getProperty(Addon.Cover) : undefined;
        this.headerData = {
            author: null,
            header: null,
            categoryUrl: (_b = this.parent) === null || _b === void 0 ? void 0 : _b.get('categoryUrl'),
            ads: ((_c = this.module.content) === null || _c === void 0 ? void 0 : _c.ads) || null,
            anchors: (_e = (_d = this.parent) === null || _d === void 0 ? void 0 : _d.get('properties').anchors) !== null && _e !== void 0 ? _e : [],
            theme: ((_f = this.module.content) === null || _f === void 0 ? void 0 : _f.theme) || null,
            cover: {
                image: null,
                video: null,
                videoSettings: ((_g = this.module.content) === null || _g === void 0 ? void 0 : _g.videoSettings) || {},
                gallery: null,
                hideDescription: typeof this.cover === 'object' && this.cover !== null ? (this.cover.hideDescription || false)
                    : false
            },
            commentsCount: (_j = (_h = this.parent) === null || _h === void 0 ? void 0 : _h.get('commentsCount')) !== null && _j !== void 0 ? _j : null,
            lead: ((_k = this.parent) === null || _k === void 0 ? void 0 : _k.hasProperty(Addon.Lead)) ? this.parseLead(this.parent.getProperty(Addon.Lead)) : null,
            meta: (_l = this.parent) === null || _l === void 0 ? void 0 : _l.getProperty(Addon.Meta),
            labels: null,
            options: {
                hasPaywall: (_o = (_m = this.parent) === null || _m === void 0 ? void 0 : _m.get('properties').paywall) !== null && _o !== void 0 ? _o : false,
                hidePublicationDate: this.canHidePublicationDate ? ((_q = (_p = this.parent) === null || _p === void 0 ? void 0 : _p.getOption('hidePublicationDate')) !== null && _q !== void 0 ? _q : false) : false,
                sponsored: (_s = (_r = this.parent) === null || _r === void 0 ? void 0 : _r.getOption('sponsored')) !== null && _s !== void 0 ? _s : false
            },
            contentProperties: {
                canonicalUrl: (_t = this.parent) === null || _t === void 0 ? void 0 : _t.get('properties').canonicalUrl,
                site: (_u = this.parent) === null || _u === void 0 ? void 0 : _u.get('properties').site,
                videoAdsTag: (_v = this.parent) === null || _v === void 0 ? void 0 : _v.get('properties').videoAdsTag
            },
            parent: (_x = (_w = this.parent) === null || _w === void 0 ? void 0 : _w.get('parent')) !== null && _x !== void 0 ? _x : null,
            pdf: (_z = (_y = this.parent) === null || _y === void 0 ? void 0 : _y.get('pdf')) !== null && _z !== void 0 ? _z : null,
            publicationDate: (_0 = this.parent) === null || _0 === void 0 ? void 0 : _0.get('publicationDate'),
            readingTime: (_2 = (_1 = this.parent) === null || _1 === void 0 ? void 0 : _1.get('readingTime')) !== null && _2 !== void 0 ? _2 : null,
            title: (_4 = (_3 = this.parent) === null || _3 === void 0 ? void 0 : _3.get('title')) !== null && _4 !== void 0 ? _4 : '',
            urlPath: (_6 = (_5 = this.parent) === null || _5 === void 0 ? void 0 : _5.get('urlPath')) !== null && _6 !== void 0 ? _6 : ''
        };
        this.forceHideAd = false;
        this.likesCount = (_9 = (_8 = (_7 = this.parent) === null || _7 === void 0 ? void 0 : _7.reactionsCount) === null || _8 === void 0 ? void 0 : _8.like) !== null && _9 !== void 0 ? _9 : 0;
        this.isLiked = false;
        this.emptyAds = () => {
            console.log('Empty cover Ad');
        };
    }
    watchEvents() {
        if (!this.eventBus) {
            return;
        }
        this.eventBus.handle('ui:video-player.play', this.hideAds);
    }
    hideAds() {
        this.forceHideAd = true;
    }
    get canHidePublicationDate() {
        return this.parent.getOption('hidePublicationDate') && typeof this.parent.getOption('hidePublicationDate') === 'boolean';
    }
    fetchImage(cover) {
        let image = null;
        try {
            image = typeof cover === 'object' && cover !== null &&
                typeof cover.image === 'object' && cover.image !== null && !!cover.image.value
                ? this.relatedService.resolveSync(cover.image) : null;
        }
        catch (e) {
            image = null;
        }
        // Overwriting image data by CoverAddon data
        if (image && typeof cover === 'object' && cover !== null) {
            const shouldOverride = typeof cover.override === 'undefined' ? false : cover.override;
            if (shouldOverride && typeof cover.caption === 'string') {
                image.caption = cover.caption;
            }
            if (shouldOverride && typeof cover.alt === 'string') {
                image.alt = cover.alt;
            }
            if (shouldOverride && typeof cover.imageAuthor === 'string') {
                image.author = cover.imageAuthor;
            }
        }
        return image;
    }
    fetchAuthor(author) {
        try {
            return this.relatedService.resolveSync(author);
        }
        catch (e) {
            console.warn(e);
        }
        return null;
    }
    fetchVideo(cover) {
        let video = null;
        try {
            if (typeof cover !== 'object' || cover === null) {
                video = null;
            }
            else {
                const videoFile = typeof cover.video === 'object' && cover.video !== null &&
                    typeof cover.video.file === 'object' && !!cover.video.file.value
                    ? this.relatedService.resolveSync(cover.video.file) : null;
                video = {
                    ...cover.video
                    // file: videoFile
                };
            }
        }
        catch (e) {
            video = null;
        }
        return video;
    }
    fetchGallery(cover) {
        let gallery = null;
        try {
            if (typeof cover === 'object' &&
                cover !== null &&
                typeof cover.gallery === 'object' &&
                cover.gallery !== null) {
                const imageCollection = this.relatedService.resolveSync(cover.gallery);
                if (imageCollection) {
                    gallery = (Array.isArray(imageCollection) ? imageCollection : [imageCollection]);
                }
            }
            else {
                gallery = null;
            }
        }
        catch (e) {
            gallery = null;
        }
        return gallery;
    }
    fetchLabels(labels) {
        if (typeof labels !== 'object' || labels === null || !Array.isArray(labels) || !labels.length) {
            return null;
        }
        const result = [];
        for (const l of labels) {
            try {
                const label = this.relatedService.resolveSync(l);
                if (label) {
                    result.push(label);
                }
            }
            catch (e) {
                console.warn(e);
            }
        }
        return result;
    }
    /**
     * @inheritDoc
     */
    async fetchRelated() {
        if (!this.parent) {
            return;
        }
        try {
            const cover = this.parent.hasProperty(Addon.Cover) ? this.parent.getProperty(Addon.Cover) : undefined;
            this.headerData.cover.image = this.fetchImage(cover);
            this.headerData.cover.video = this.fetchVideo(cover);
            this.headerData.cover.gallery = this.fetchGallery(cover);
            this.headerData.author = this.fetchAuthor(this.parent.get('author'));
            this.headerData.labels = this.fetchLabels(this.parent.getProperty(Addon.Labels));
            this.onReady();
        }
        catch (e) {
            this.onError(e);
        }
    }
    get contentMetadata() {
        var _a, _b, _c, _d, _e;
        dayjs.extend(utc);
        dayjs.extend(timezone);
        let metaImage = '';
        if (this.headerData.cover.image) {
            metaImage = this.headerData.cover.image.url;
        }
        if (this.headerData.cover.gallery && this.headerData.cover.gallery[0]) {
            metaImage = this.headerData.cover.gallery[0].url;
        }
        return {
            '@context': 'https://schema.org',
            '@graph': [
                {
                    '@type': 'NewsArticle',
                    mainEntityOfPage: {
                        '@type': 'WebPage',
                        '@id': this.headerData.contentProperties.canonicalUrl
                    },
                    headline: (_a = this.headerData.meta) === null || _a === void 0 ? void 0 : _a.title,
                    articleSection: this.headerData.parent ? this.headerData.parent.name : '',
                    description: (_b = this.headerData.meta) === null || _b === void 0 ? void 0 : _b.description,
                    image: metaImage,
                    datePublished: dayjs.tz(this.headerData.publicationDate, 'Europe/Warsaw').format('YYYY-MM-DDTHH:mm:ssZ'),
                    dateModified: dayjs.tz(this.headerData.publicationDate, 'Europe/Warsaw').format('YYYY-MM-DDTHH:mm:ssZ'),
                    author: [
                        {
                            '@type': 'Person',
                            name: `${(_c = this.headerData.author) === null || _c === void 0 ? void 0 : _c.firstName} ${(_d = this.headerData.author) === null || _d === void 0 ? void 0 : _d.lastName}`,
                            url: `https://${this.headerData.contentProperties.site.domain}${(_e = this.headerData.author) === null || _e === void 0 ? void 0 : _e.url}`
                        }
                    ],
                    inLanguage: this.headerData.contentProperties.site.locale,
                    isAccessibleForFree: !this.headerData.options.hasPaywall,
                    url: this.headerData.contentProperties.canonicalUrl,
                    publisher: {
                        '@id': `https://${this.headerData.contentProperties.site.domain}`,
                        '@type': 'NewsMediaOrganization',
                        name: this.headerData.contentProperties.site.name,
                        logo: this.headerData.contentProperties.site.logo.light
                    }
                }
            ]
        };
    }
    parseLead(markup) {
        let html;
        let obj;
        try {
            obj = this.DeMarked.convertMDToObjects(markup);
            html = this.DeMarked.convertObjectsToHTML(obj);
            this.onReady();
            return html;
        }
        catch (e) {
            this.onError(e);
            return '';
        }
    }
    get isLazy() {
        return this.module.isLazyLoaded;
    }
    get videoConfig() {
        return {
            origin: this.headerData.contentProperties.site.address,
            videoAdsTag: this.headerData.contentProperties.videoAdsTag
        };
    }
    get shareUrl() {
        if (typeof document === 'undefined') {
            return this.headerData.urlPath;
        }
        if (!this.headerData.urlPath) {
            return document.location.origin + document.location.pathname;
        }
        if (this.headerData.urlPath.indexOf('http') >= 0) {
            return this.headerData.urlPath;
        }
        return document.location.origin + '/' + this.headerData.urlPath;
    }
    onSocialClick(social) {
        this.shareService.share(social, {
            url: this.shareUrl,
            meta: this.headerData.meta
        });
    }
    get pdfAction() {
        if (!this.headerData.pdf) {
            return null;
        }
        return {
            callback: () => {
                if (this.pdfService && this.headerData.pdf) {
                    const previewMatch = window.location.href.match(/\/preview\/([^/?#]+)/);
                    const previewValue = previewMatch ? previewMatch[1] : null;
                    const pdfData = { ...this.headerData.pdf };
                    if (previewValue) {
                        pdfData.path = `${pdfData.path}?preview=${previewValue}`;
                    }
                    return this.pdfService.download(pdfData);
                }
            },
            disabled: !this.headerData.pdf.path,
            icon: 'download-new',
            title: this.$t('modules.ArticleHeader.pdf').toString(),
            hideForMobile: true
        };
    }
    get actions() {
        var _a;
        return [
            {
                callback: this.toggleLike,
                icon: this.isLiked ? 'like-full' : 'like-new',
                title: this.$t('modules.ArticleHeader.like').toString(),
                label: this.likesCount ? this.likesCount.toString() : '',
                hideForMobile: false
            },
            ...(((_a = this.parent) === null || _a === void 0 ? void 0 : _a.getOption('comments')) ? [
                {
                    callback: this.openComments,
                    icon: 'comment-new',
                    title: this.$t('modules.ArticleHeader.comment').toString(),
                    label: this.headerData.commentsCount ? this.headerData.commentsCount.toString() : undefined,
                    hideForMobile: false
                }
            ] : []),
            // TODO
            // {
            //   callback: () => { alert('Bookmark clicked') },
            //   icon: 'bookmark-add',
            //   title: this.$t('modules.ArticleHeader.bookmark').toString(),
            //   hideForMobile: false
            // },
            {
                callback: () => {
                    window.print();
                },
                icon: 'print-new',
                title: this.$t('modules.ArticleHeader.print').toString(),
                hideForMobile: true
            },
            ...(this.pdfAction ? [this.pdfAction] : []),
            {
                callback: this.isMobile ? this.onShare : undefined,
                icon: 'share-new',
                title: this.$t('modules.ArticleHeader.share').toString(),
                hideForMobile: false,
                children: this.isMobile ? undefined : this.shareButtons
            }
        ];
    }
    get shareButtons() {
        return [
            {
                callback: () => {
                    return this.onSocialClick(ShareType.CopyLink);
                },
                icon: 'link-new',
                title: this.$t('share.link.name').toString(),
                label: this.$t('share.link.label').toString(),
                className: '--separated'
            },
            {
                callback: () => {
                    this.onSocialClick(ShareType.Facebook);
                },
                icon: 'facebook',
                title: this.$t('share.facebook.name').toString(),
                label: this.$t('share.facebook.label').toString()
            },
            {
                callback: () => {
                    this.onSocialClick(ShareType.LinkedIn);
                },
                icon: 'linkedin',
                title: this.$t('share.linkedin.name').toString(),
                label: this.$t('share.linkedin.label').toString()
            },
            {
                callback: () => {
                    this.onSocialClick(ShareType.Twitter);
                },
                icon: 'x',
                title: this.$t('share.twitter.name').toString(),
                label: this.$t('share.twitter.label').toString()
            }
            // {
            //   callback: () => {
            //     this.onSocialClick(ShareType.Email)
            //   },
            //   icon: 'email',
            //   title: this.$t('share.email').toString(),
            //   label: this.$t('share.email').toString()
            // }
        ];
    }
    onVideoPause(payload) {
        this.eventBus.emit('ui:video-player.pause', payload);
    }
    onVideoPlay(payload) {
        this.eventBus.emit('ui:video-player.play', payload);
    }
    openComments() {
        if (!this.parent) {
            return;
        }
        this.commentService.open(this.parent);
    }
    initReactions() {
        var _a, _b;
        this.isLiked = (_b = ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.options.userReactions).like) !== null && _b !== void 0 ? _b : false;
    }
    async toggleLike() {
        if (!this.parent) {
            return;
        }
        try {
            const data = await this.reactionsService.toggleLike('content', this.parent.contentId);
            if (!data) {
                return;
            }
            this.likesCount = data.reactionsCount.like;
            this.isLiked = data.reactionAdded;
        }
        catch (e) {
            console.error(e);
        }
    }
    onShare() {
        navigator.share({
            url: this.shareUrl
        });
    }
};
__decorate([
    Prop({ type: Object, required: false, default: null })
], ArticleTeaserModuleUi.prototype, "pdfService", void 0);
__decorate([
    Prop({ type: Object, required: true })
], ArticleTeaserModuleUi.prototype, "shareService", void 0);
__decorate([
    Prop({ type: Object, required: true })
], ArticleTeaserModuleUi.prototype, "commentService", void 0);
__decorate([
    Prop({ type: Object, required: true })
], ArticleTeaserModuleUi.prototype, "reactionsService", void 0);
ArticleTeaserModuleUi = __decorate([
    Component({
        name: 'ArticleTeaserModuleUi',
        components: {
            ArticleHeader,
            AdBannerModuleUi
        },
        mounted() {
            this.watchEvents();
            this.initReactions();
        },
        async created() {
            await this.fetchRelated();
        },
        template: `
    <ArticleHeader
      :class="{ '--loaded': !isLoading }"
      :content="headerData"
      :actions="actions"
      :pdfAction="pdfAction"
      :fallbackImage="fallbackImage"
      :isMobile="isMobile"
      :isLazy="isLazy"
      :videoConfig="videoConfig"
      :windowService="windowService"
      @social-click="onSocialClick"
      @pause="onVideoPause"
      @play="onVideoPlay"
    >
      <template v-slot="ad">
        <AdBannerModuleUi
          v-if="headerData.ads"
          class="article-header__ad"
          v-bind="{ eventBus, fallbackImage, onEmptyCallback: emptyAds, module: headerData.ads, parent, pdfService,
          shareService, theme, windowService, isMobile, relatedService, forceHide: forceHideAd}"
        />
      </template>

      <component :is="'script'" type="application/ld+json" v-html="JSON.stringify(contentMetadata)" />
    </ArticleHeader>
  `
    })
], ArticleTeaserModuleUi);
export { ArticleTeaserModuleUi };
